import NotFoundPage from '@gameday/common/components/form/Common/NotFoundPage'
import withWidth from '@material-ui/core/withWidth'
import { Helmet } from 'react-helmet'
import { hot } from 'react-hot-loader/root'
import { Route, Switch } from 'react-router-dom'

import GlobalStyle from '../../components/common/GlobalStyle'
import routes from '../../constants/routes/top'

const App = () => {
  const renderApp = () => {
    const routeItems = routes.map(route => (
      <Route key={route.id} exact={!route.noExact} path={route.path} component={route.component} />
    ))

    return (
      <>
        <Helmet titleTemplate="%s - GameDay" defaultTitle="GameDay">
          <meta name="description" content="A GameDay application" />
        </Helmet>
        <Switch>
          {routeItems}
          <Route component={() => <NotFoundPage />} />
        </Switch>
      </>
    )
  }

  return (
    <>
      <GlobalStyle whiteColor />
      {renderApp()}
    </>
  )
}

export default hot(withWidth()(App))
